export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const CHANGE_PASSWORD_SIGNOUT = "CHANGE_PASSWORD_SIGNOUT";

export const changePassword = (user) => {
    //console.log("user",user);
    return {
        type: CHANGE_PASSWORD,
        user
    };
};